module.exports = "https://www.gc-pro.gnp.com.mx/e97da4069e40d18dc9705d98c3d65f24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/100.svg
// module id = 8041
// module chunks = 0